import SkeletonEntityCard from './skeletonEntityCard';

interface SkeletonCardListProps {
  rows: number[];
  count?: number;
  withSubcontentOnFirstRow?: boolean;
  withHeader?: boolean;
  actionCount?: number;
}

/**
 * Renders no wrapper of its own so the placeholder cards are laid out by the
 * same flex container that lays out the real ones.
 */
const SkeletonCardList = ({
  rows,
  count = 4,
  withSubcontentOnFirstRow = false,
  withHeader = true,
  actionCount,
}: SkeletonCardListProps) => (
  <>
    {Array.from({ length: count }, (_, index) => (
      <SkeletonEntityCard
        key={`skeleton-card-${index}`}
        rows={rows}
        withSubcontentOnFirstRow={withSubcontentOnFirstRow}
        withHeader={withHeader}
        actionCount={actionCount}
      />
    ))}
  </>
);

export default SkeletonCardList;
